// import { BookingModel, ID, Response } from "../../../../../_metronic/helpers"

import { BookingModel, ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Booking = {
  id?: ID
  name?: string
  booking_name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type BookingsQueryResponse = Response<Array<BookingModel>>

export const initialBooking: Booking = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
